export const PAGE_SCROLL_ID = "idx-page-scroll";

export function getPageScrollElement() {
  if (typeof document === "undefined") return null;
  return document.getElementById(PAGE_SCROLL_ID);
}

export function getPageScrollY() {
  const el = getPageScrollElement();
  if (el) return el.scrollTop;
  if (typeof window !== "undefined") return window.scrollY;
  return 0;
}

export function addPageScrollListener(handler, options) {
  if (typeof window === "undefined") return () => {};

  let target = null;
  let attached = false;
  let rafId = 0;

  const listener = (event) => handler(event);

  const attach = (el) => {
    if (attached || !el) return;
    target = el;
    target.addEventListener("scroll", listener, options);
    attached = true;
  };

  const tryAttach = () => {
    attach(getPageScrollElement());
    if (!attached) {
      rafId = window.requestAnimationFrame(tryAttach);
    }
  };

  tryAttach();

  return () => {
    if (rafId) window.cancelAnimationFrame(rafId);
    if (attached && target) {
      target.removeEventListener("scroll", listener, options);
    }
  };
}

/** Scroll an element to the top of the page scrollport (below fixed chrome). */
export function scrollElementToTopOfPageScroll(element, offsetPx = 0) {
  const scrollEl = getPageScrollElement();
  if (!scrollEl || !element) return;
  const scrollRect = scrollEl.getBoundingClientRect();
  const elRect = element.getBoundingClientRect();
  const top =
    scrollEl.scrollTop + (elRect.top - scrollRect.top) - offsetPx;
  scrollEl.scrollTo({ top: Math.max(0, top), behavior: "auto" });
}
